// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ElementosDocumentosPdf_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/elementos_documentos_pdf/salvar
 * and POST /config/elementos_documentos_pdf/save
 *
 * Saves (creates or updates) a PDF page element (header/footer).
 * - If element with given name exists: updates it
 * - If element with given name doesn't exist: creates new element
 *
 * Calls external html2pdf-service API (not local database).
 */
import { registerContract } from './validate'

export interface ElementosDocumentosPdf_SalvarInput {
name: string
type: string
data: string
}

registerContract('ElementosDocumentosPdf_SalvarInput', {
  name: { type: 'string',  required: true },
  type: { type: 'string',  required: true },
  data: { type: 'string',  required: true },
})
